import {buildLoginRedirect} from '@sphericsio/mvp-ui-common';

const {storeRedirectPath, useRedirectPath} = buildLoginRedirect(['/login', '/logout']);

export {storeRedirectPath, useRedirectPath};
